export enum UserStatusEnum {
  Active = 1, // Intresseanmäld
  Inactive = 2, // Betald
}
